import { jsPDF } from "jspdf";
import { getBarcodeBySku, getBarcodeByStockId, getQrcodeByProductId, getQrcodeByStockId, getQrTextByStockId, applyPriceCode, formatNormalPrice } from "../helpers/barcodeHelper";
import { estimateQrModuleCount } from "./template3";
import { formatWeightValue, getPrintPieceCount } from "./printQuantity";

// Offline QR is drawn as a pre-rendered image (unlike template3's client-sized
// ^BQ), so there's no magnification to tune - the only lever here is the
// printed mm size. Label is 14mm tall (measured with a ruler against a real
// print - see the page format above). A real print at the 12.7mm/1.3mm-margin
// setting still had room to spare at the bottom edge, so grew the ceiling by
// another 0.5mm (to 13.2mm) and gave that same 0.5mm back off the margin
// (1.3mm -> 0.8mm) so the extra size extends downward into the confirmed
// spare space rather than pushing the QR upward. Math still says this
// doesn't reach a reliably-scannable dots/module ratio at 5+ stones (41
// modules would need ~20.5mm, more than the whole label), but at the lower
// end (3-4 stones, ~29-33 modules) the extra size over the original 11.5mm
// baseline still measurably helps. Y is computed from size, not a fixed
// value, since a bigger square needs to start higher to still end within
// the label.
const OFFLINE_QR_BASE_MM = 11.5;
const OFFLINE_QR_BASE_MODULE_COUNT = 21;
const OFFLINE_QR_MAX_MM = 13.2;
const OFFLINE_QR_LABEL_HEIGHT_MM = 14;
const OFFLINE_QR_BOTTOM_MARGIN_MM = 0.8;
function getOfflineQrSizeMM(text) {
  const moduleCount = estimateQrModuleCount(text);
  const scaled = OFFLINE_QR_BASE_MM * (moduleCount / OFFLINE_QR_BASE_MODULE_COUNT);

  return Math.min(OFFLINE_QR_MAX_MM, Math.max(OFFLINE_QR_BASE_MM, scaled));
}
function getOfflineQrYMM(sizeMM) {
  return OFFLINE_QR_LABEL_HEIGHT_MM - sizeMM - OFFLINE_QR_BOTTOM_MARGIN_MM;
}


export const template2 = async (barcode, dataList, qrcodedata, qrcode = "offline", config = {}, returnType = "save") => {

console.log(returnType,'returnType')
  // let generatedQrcode ;
  // const {data} = barcode

  // const fontSizeStoneBylength = {
  //     "2" : 5,
  //     "3" : 4,
  //     "4" : 3,
  //     "5" : 3
  //   }
  const doc = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    // Measured with a ruler against a real printed label: physically 14mm
    // tall, not the 13mm this was set to before - the extra 1mm was going
    // unused at the top while the offline QR still clipped at the bottom
    // edge. Growing the page only extends the bottom (Y=0 stays the label's
    // top, unaffected), so every other element's absolute Y position here is
    // untouched by this change.
    format: [75, 14],
    compressPdf: false,
    userUnit: 300, // set the DPI here. Web uses 72 but you can change to 150 or 300

  });

  const imageConfig = config.image_config;
  const imagePosition = imageConfig?.position || { x: 1, y: 1 };
  const imageSize = imageConfig?.size || { width: 8, height: 8 };

  // console.log(InventoryList,'InventoryList')
  dataList.map(async (v, k) => {


    // const qr_data = {
    //   stone_count: v.stone_pcs_total,
    //   stone_code: v.stone_code,
    //   size_name: v.size_name,
    //   metal_name: v.metal_name,
    //   net_weight: v.NetWt,
    //   Stones: v.Stones
    // }






    // doc.addFileToVFS("calibri-bold.ttf",font)
    // doc.addFont('calibri-bold-bold.ttf', 'calibri-bold', 'bold');
    // doc.setFont('calibri', "bold")

    // var callAddFont = function () {
    //   this.addFileToVFS('calibri-bold-bold.ttf', font);
    //   this.addFont('calibri-bold-bold.ttf', 'calibri-bold', 'bold');
    //   };

    //   jsPDF.API.events.push(['addFonts', callAddFont])

    // doc.setFont('helvetica', 'bold');

    // console.log(doc)

    doc.setFont('helvetica', 'bold');
    doc.setFontSize('6');

    if (config.image === true && imageConfig?.data?.startsWith("data:image/png;base64,")) {
      try {
        doc.addImage(
          imageConfig.data,
          imageConfig.format || "PNG",
          Number(imagePosition.x) || 1,
          Number(imagePosition.y) || 1,
          Number(imageSize.width) || 8,
          Number(imageSize.height) || 8,
          undefined,
          "FAST"
        );
      } catch (imageError) {
        console.warn("Unable to render barcode profile image", imageError);
      }
    }

    doc.text(v.SKU, 31.5, 2.5, 0);

    const collectionText = config.collection === true
      ? (v.collection_code || v.collection_name)
      : "";
    if (collectionText) {
      doc.setFontSize('4');
      doc.text(collectionText, 31.5, 3.2, 0);
    }
    const barcodeY = collectionText ? 4.0 : 3.3;

    if (config.barcode === true) {

      if (config.barcode_display === "stock_id") {
        doc.addImage(getBarcodeByStockId(barcode.data, v.stock_id), 'PNG', 31.5, barcodeY, 20, 4.0, null, "SLOW");
      } else if (config.barcode_display === "sku") {
        console.log(barcode.data, 'skuuuu')
        console.log(v.SKU, 'skuuuu')
        doc.addImage(getBarcodeBySku(barcode.data, v.SKU), 'PNG', 31.5, barcodeY, 20, 4.0, null, "SLOW");
      } else {
        doc.addImage(getBarcodeByStockId(barcode.data, v.stock_id), 'PNG', 31.5, barcodeY, 20, 4.0, null, "SLOW");

      }

    }


    // doc.setFontSize( '6');

    // Remove the currency symbol and commas

    // let numericString = parseFloat(v.price.trim().replace(/[฿, ]/g, '')).toFixed(2);
  

    let numericString ;
    if(isNaN(v.price)){
      numericString = v.price.replace(/[^0-9.]/g, '');
    }else{
      numericString = v.price;
    }

    function numberWithCommas(x) {
      return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  }
    

    if (config.price === true) {

      if(v.price){
      
        if (config.price_display==="with_currency") {
          if (isNaN(numericString)) {
            doc.text(formatNormalPrice(numberWithCommas(numericString), config, v.currency), 31.5, 12, 0);
      
          } else {
        
            doc.text(formatNormalPrice(numberWithCommas(parseInt(numericString)), config, v.currency), 31.5, 12, 0);
      
          }
      
        } else {
          if (isNaN(numericString)) {
          
            doc.text(applyPriceCode(numberWithCommas(numericString), config, v), 31.5, 12, 0);
      
          }else{
            doc.text(applyPriceCode(numberWithCommas(parseFloat(numericString).toFixed(2)), config, v), 31.5, 12, 0);
      
          }
        }
        
      
      
      }
         
      
          }

    

    doc.text(v.stock_id, 31.5, 9.8, 0);

    if (config.metal === true) {
      if(v.metal_code){
              doc.text(v.metal_code, 44.5, 9.8, 0);

      }
      // doc.text(v.metal_code, 44.5, 9.8, 0);
    }

    const nwt = formatWeightValue(v.NetWt) + "g"
    const gwt = formatWeightValue(v.GrossWt) + "g"
    const showPieceCount = config.pcs !== false;
    const pieceText = `${getPrintPieceCount(v)}p`;


    if (config.weight === true) {
      const weightFontSize = 6;
      doc.setFontSize(weightFontSize);
      if (config.weight_display === "nwt") {
        const weightTextWidth = doc.getTextWidth(nwt);
        doc.text(nwt, 45.5, 12, 0);
        if (showPieceCount) {
          doc.setFontSize(4);
          doc.text(pieceText, 45.5 + weightTextWidth + 0.4, 11.5, 0);
        }
        // doc.text( nwt, 47 ,12, 0);

      } else {
        const weightTextWidth = doc.getTextWidth(gwt);
        doc.text(gwt, 45.5, 12, 0); //for no currency layout
        if (showPieceCount) {
          doc.setFontSize(4);
          doc.text(pieceText, 45.5 + weightTextWidth + 0.4, 11.5, 0);
        }
        // doc.text( gwt, 47 ,12, 0);

      }
    }



    if (config.qr === true) {

      if (config.qr_type_display === "online") {
        doc.addImage(qrcodedata.data, 'PNG', 60, 1.5, 10, 10, null, "SLOW");

      }else if(config.qr_type_display === "product_page") {
        doc.addImage(getQrcodeByProductId(qrcodedata.data, v.product_id), 'PNG', 60, 1, 11.5, 11.5, null, "SLOW");

       }else if(config.qr_type_display === "offline")  {
        const offlineQrSize = getOfflineQrSizeMM(getQrTextByStockId(qrcodedata.data, v.stock_id));
        const offlineQrY = getOfflineQrYMM(offlineQrSize);
        doc.addImage(getQrcodeByStockId(qrcodedata.data, v.stock_id), 'PNG', 60, offlineQrY, offlineQrSize, offlineQrSize, null, "SLOW");

      }else{
        doc.addImage(getQrcodeByStockId(qrcodedata.data, v.stock_id), 'PNG', 60, 1, 11.5, 11.5, null, "SLOW");

      }
    } else {
      //   v.Stones.map((v,k,arr)=>{
      //   if(v.stone_code.length>=v.shape_code.length){
      //     doc.setFontSize( fontSizeStoneBylength[v.stone_code.length])
      //   }else{
      //     doc.setFontSize( fontSizeStoneBylength[v.shape_code.length]);
      //   }
      //  let space = 2.5;
      //   // const text = v.stone_code+" "+v.shape_code+" "+" "+v.Pcs+" "+v.Cts;
      //   doc.text( v.stone_code, 55,space*(k+1), 0);
      //   doc.text( v.shape_code, 60,space*(k+1), );
      //   doc.text( v.Pcs, 65,space*(k+1));
      //   doc.text( v.Cts, 70,space*(k+1), );
      // })
    }
    // doc.addImage("", 'PNG', 55, 1.5, 10,10,null,"SLOW");


    if (k + 1 < dataList.length) {
      doc.addPage();

    }
  })
  switch (returnType) {
    case "save":
      return doc.save("barcode.pdf");
    case "uri":
      return doc.output('datauristring');
     
    case "printout":
      doc.autoPrint({ variant: 'non-conform' })
      return doc.output('dataurlnewwindow');
      // return doc.addJS('print({});');
  
    default:
      return doc.save("barcode.pdf");
  }

}
